export default {
  // async
  GET_PROFILE_INFO: 'GET_PROFILE_INFO',
  GET_PROFILE_INFO_CLEAR: 'GET_PROFILE_INFO_CLEAR',
  CANCEL_SUB: 'CANCEL_SUB',
  REACTIVATE_SUB: 'REACTIVATE_SUB',
  UPGRADE_COST: 'UPGRADE_COST',
  GET_REF_SETTINGS: 'GET_REF_SETTINGS',
  GET_REF_PAYMENTS: 'GET_REF_PAYMENTS',
  GET_REF_USERS: 'GET_REF_USERS',
  POST_WITHDRAW: 'POST_WITHDRAW',
  UPDATE_REF_CODE: 'UPDATE_REF_CODE',
};
